import { AddOnItem } from "@/redux/slices/addOn/types";
import { GetAddOnRawResponse, GetAddOnResponse } from "./types";


export const transformAddOns = (res: GetAddOnRawResponse) => {
  const { _embedded: { add_on } } = res;
  const addOns: Array<AddOnItem> = [];
  const features: Array<AddOnItem> = [];

  add_on.forEach((i) => {
    const item = {
      identifier: i.identifier,
      name: i.name,
      cost: i.cost,
      costType: i.cost_type,
      currency: i.currency,
      enabled: i.enabled,
      type: i.type,
      freeTrialPeriod: i.free_trial_period,
      freeTrialExpiry: i.free_trial_expiry,
    };

    if (item.type === "addon") addOns.push(item);
    else if (item.type === "feature") features.push(item);
  });

  const response: GetAddOnResponse = {
    data: { addOns, features },
  };

  return response;
};